import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormHelperText,
  Autocomplete
} from "@mui/material";
import { Snackbar, Alert } from "@mui/material";
import { useAuth } from '../context/AuthContext';


const CityPopupModal = ({ onClose, onCityAdded, prefill, connectionString }) => {
  const path = connectionString;
  const { user, selectedCompany } = useAuth();
  const userId = user?.UserId || null;
  const [city, setCity] = useState("");
  const [stateName, setStateName] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState("India");
  const [statesList, setStatesList] = useState([]);
  const [statesLoading, setStatesLoading] = useState(false);

  // New: field-level error shown under Country field for status 400
  const [fieldError, setFieldError] = useState("");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // success | error | warning | info
  });


  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  // Fetch states from API on mount
  useEffect(() => {
    const fetchStates = async () => {
      setStatesLoading(true);
      try {
        // console.log("🔍 [CityPopupModal] Starting fetch from http://103.133.215.205:82/api/state/gstState");
         console.log("🔍 [CityPopupModal] Starting fetch from https://services.reonbook.com/state/gstState");

        // Use fetch API directly to avoid axios interceptors adding x-session-token header
        // const response = await fetch("http://103.133.215.205:82/api/state/gstState");
        const response = await fetch("https://services.reonbook.com/state/gstState");

        console.log("🔍 [CityPopupModal] Response status:", response.status);
        console.log("🔍 [CityPopupModal] Response ok:", response.ok);
        console.log("🔍 [CityPopupModal] Response headers:", {
          contentType: response.headers.get('content-type'),
          contentLength: response.headers.get('content-length')
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("🔍 [CityPopupModal] HTTP error response body:", errorText);
          throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
        }

        const data = await response.json();
        console.log("🔍 [CityPopupModal] Full response data:", data);
        console.log("🔍 [CityPopupModal] Data type:", typeof data);
        console.log("🔍 [CityPopupModal] Is array?:", Array.isArray(data));

        // Handle different response formats
        let states = [];

        // Check if response is {success: true, data: [...states]}
        if (data && typeof data === 'object' && Array.isArray(data.data)) {
          states = data.data;
          console.log("🔍 [CityPopupModal] Detected {success, data: array} format, extracting states, length:", states.length);
        } else if (Array.isArray(data) && data.length === 2 && Array.isArray(data[1])) {
          states = data[1];
          console.log("🔍 [CityPopupModal] Detected [boolean, array] format, extracting states, length:", states.length);
        } else if (Array.isArray(data)) {
          states = data;
          console.log("🔍 [CityPopupModal] Detected array format, length:", states.length);
        } else if (data && typeof data === 'object') {
          // If response is an object, convert to array
          states = Object.values(data);
          console.log("🔍 [CityPopupModal] Detected object format, converted to array, length:", states.length);
        }

        // Log individual state items to see structure
        if (states && states.length > 0) {
          console.log("🔍 [CityPopupModal] First state item:", states[0]);
          console.log("🔍 [CityPopupModal] First state keys:", Object.keys(states[0]));
        }

        console.log("🔍 [CityPopupModal] Final states to set, total count:", states.length);
        setStatesList(states);
        console.log("✅ [CityPopupModal] States fetched successfully!");
      } catch (error) {
        console.error("❌ [CityPopupModal] Error fetching states:", error);
        console.error("❌ [CityPopupModal] Error name:", error.name);
        console.error("❌ [CityPopupModal] Error message:", error.message);
        console.error("❌ [CityPopupModal] Full error:", error);

        setSnackbar({
          open: true,
          message: `Failed to load states: ${error.message}`,
          severity: "error"
        });
        setStatesList([]);
      } finally {
        setStatesLoading(false);
      }
    };

    fetchStates();
  }, []);

  // Prefill logic
  useEffect(() => {
    if (prefill) {
      setCity(prefill.city || "");
      setStateName(prefill.state || "");
      setStateCode(prefill.stateCode || "");
    }
  }, [prefill]);

  const handleAddCity = async () => {
    // clear previous field error when attempting again
    setFieldError("");

    if (!city.trim() || !stateName.trim() || !stateCode.trim()) {
      setSnackbar({
        open: true,
        message: "Please enter city, state, and GST state code.",
        severity: "warning"
      });
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${path}/api/cities`, {
        city: city.trim(),
        state: stateName.trim(),
        stateCode: stateCode.trim(),
        country: country.trim(),
        AddUserId: userId
      });

      // Use HTTP status to decide behaviour and show server-sent message if any
      const status = response.status;
      const msg = response.data?.message ?? response.statusText ?? "No message from server";

      if (status === 201) {
        // Created
        setSnackbar({
          open: true,
          message: msg,
          severity: "success"
        });
        if (onCityAdded) {
          setTimeout(() => {
            onCityAdded({
              city: city.trim(),
              state: stateName.trim(),
              stateCode: stateCode.trim(),
              country: country.trim(),
              cityId: response.data.cityId ?? null,
            });
          }, 600)
        }
        setTimeout(() => {
          onClose();
          console.log("hii")
        }, 600);
      } else if (status === 200) {
        // City exists with same state/stateCode (backend returns 200)
        setSnackbar({
          open: true,
          message: msg,
          severity: "success"
        });
        if (response.data?.cityId && onCityAdded) {
          onCityAdded({
            city: city.trim(),
            state: stateName.trim(),
            stateCode: stateCode.trim(),
            country: country.trim(),
            cityId: response.data.cityId,
          });
        }
        setTimeout(() => {
          onClose();
        }, 600);
      } else if (status === 400) {
        // Show message under country field (red), do not alert, do not close
        setFieldError(msg);
      } else {
        // Fallback: show alert with message
        setSnackbar({
          open: true,
          message: msg,
          severity: "error"
        });
      }
    } catch (error) {
      // If server returned an error status, axios throws and error.response will be present
      if (error.response) {
        const serverStatus = error.response.status;
        const serverMsg = error.response.data?.message ?? `Server returned ${serverStatus}`;

        if (serverStatus === 400) {
          // show under field (red) and don't alert
          setFieldError(serverMsg);
        } else {
          // other server-side error: show alert
          setSnackbar({
            open: true,
            message: serverMsg,
            severity: "error"
          });
        }
      } else {
        // Network or unexpected error
        console.error("Error adding city:", error);
        //  showSnackbar("Server error while adding city.", "error");
        setSnackbar({
          open: true,
          message: "Server error while adding city.",
          severity: "error"
        });
      }
    } finally {
      setLoading(false);
    }
  };



  return (
    <Dialog
      open
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return; // ❌ block outside click
        setTimeout(() => {
          onClose();
        }, 600);
      }}
    >
      <DialogTitle>Insert New City</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <TextField
            label="City"
            name="popupCity"
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="Enter city name"
            fullWidth
            margin="normal"
          />
          <Autocomplete
            options={Array.isArray(statesList) ? statesList : []}
            getOptionLabel={(option) => option.State || ""}
            value={Array.isArray(statesList) ? (statesList.find(s => s.State === stateName) || null) : null}
            onChange={(event, newValue) => {
              console.log("🔍 [State Change] Selected:", newValue);
              if (newValue) {
                setStateName(newValue.State || "");
                setStateCode(String(newValue.statecode || ""));
              } else {
                setStateName("");
                setStateCode("");
              }
            }}
            loading={statesLoading}
            fullWidth
            margin="normal"
            ListboxProps={{
              style: { maxHeight: '300px' }
            }}
            noOptionsText="No states available"
            onOpen={() => {
              console.log("🔍 [State Dropdown] Opened, options count:", Array.isArray(statesList) ? statesList.length : 0);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="State"
                name="popupState"
                placeholder="Select state"
                margin="normal"
              />
            )}
            renderOption={(props, option) => (
              <li {...props} key={option.statecode}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>{option.State}</span>
                  <span style={{ fontSize: '0.85rem', color: '#888', marginLeft: '10px' }}>({option.statecode})</span>
                </Box>
              </li>
            )}
          />
          <TextField
            label="GST State Code"
            name="popupStateCode"
            type="text"
            value={stateCode}
            onChange={(e) => setStateCode(e.target.value)}
            placeholder="State code (auto-filled)"
            fullWidth
            margin="normal"
            disabled
            sx={{
              "& .MuiOutlinedInput-root.Mui-disabled": {
                backgroundColor: "#f5f5f5"
              }
            }}
          />
          <TextField
            label="Country"
            name="popupCountry"
            type="text"
            value={country}
            onChange={(e) => {
              setCountry(e.target.value);
              // clear fieldError when user edits country (or you might want to clear on any edit)
              if (fieldError) setFieldError("");
            }}
            fullWidth
            margin="normal"
            error={Boolean(fieldError)}
          />
          {/* show the backend 400 message under the country field in red */}
          {fieldError && (
            <FormHelperText error sx={{ mt: 0.5 }}>
              {fieldError}
            </FormHelperText>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddCity} disabled={loading} variant="contained">
          {loading ? <CircularProgress size={24} /> : "Submit"}
        </Button>
        <Button onClick={onClose} color="error" disabled={loading}>
          Close
        </Button>
      </DialogActions>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

    </Dialog>
  );
};

export default CityPopupModal;
